import { render, staticRenderFns } from "./LastEmails.vue?vue&type=template&id=62753630"
import script from "./LastEmails.vue?vue&type=script&lang=js"
export * from "./LastEmails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports